import React, { useEffect, useState } from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";
import { api_url } from "../../constant/constant";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "react-bootstrap";
import { useNavigate, NavLink } from "react-router-dom";
import { showToast } from "../../Components/ShowToast/ToastNotification";

const CSVmanagement = () => {
  const [data, setData] = useState([]);
  const [links, setLinks] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedCSVId, setSelectedCSVId] = useState(null);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (searchVal !== "") {
      const filteredData = data.filter((item) =>
        item.original_filename.toLowerCase().includes(searchVal.toLowerCase())
      );
      setData(filteredData);
    } else {
      fetchCSVfile("");
    }
  }, [searchVal]);

  const fetchCSVfile = async (url) => {
    setLoading(true);
    let page = 1;
    if (url) {
      const temp = url.split("?page=");
      page = temp[1];
    }

    try {
      const token = localStorage.getItem("userToken");
      const response = await fetch(`${api_url}/csv/list-csvs?page=${page}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 404) {
          // ✅ Don't show toast for 404
          return;
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      setData(result.data.data);
      setLinks(result.data.links);
    } catch (error) {
      console.error("Error fetching data:", error);
      if (!error.message.includes("status: 404")) {
        showToast(t("fetcherror"), "error");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCSVfile("");
  }, []);

  const columns = React.useMemo(
    () => [
      {
        accessorKey: "original_filename",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i className="bi bi-file-earmark-text"></i> {t("CSVFileName")}
          </div>
        ),
        colName: t("CSVFileName"),
      },
      {
        accessorKey: "total_records",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i className="bi bi-file-earmark-text"></i> {t("TotalRecords")}
          </div>
        ),
        colName: t("total_records"),
      },
      {
        accessorKey: "status",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i className="bi bi-file-earmark-text"></i> {t("Status")}
          </div>
        ),
        colName: t("status"),
      },
      {
        accessorFn: (row) => row.progress?.progress,
        id: "progress", // unique ID since you're using accessorFn
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i className="bi bi-file-earmark-text"></i> {t("Progress")}
          </div>
        ),
        cell: ({ getValue }) => {
          const progress = getValue();
          return progress !== undefined ? `${progress}%` : "N/A";
        },
        colName: t("Progress"),
      },

      // {
      //   accessorKey: 'created_at',
      //   header: () => (
      //     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      //       <img src="/images/fi_clock.png" alt="Date of Creation" /> {t('DateofCreation')}
      //     </div>
      //   ),
      //   cell: ({ row }) => {
      //     const formattedDate = new Date(row.original.created_at).toLocaleDateString('en-US', {
      //       day: 'numeric',
      //       month: 'short',
      //       year: 'numeric',
      //     });
      //     return formattedDate;
      //   },
      //   colName: t('DateofCreation'),
      // },
      // {
      //   accessorKey: 'id',
      //   header: () => (
      //     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      //       <img src="/images/fi_alert-octagon.png" alt="Action" /> {t('Action')}
      //     </div>
      //   ),
      //   cell: ({ getValue }) => {
      //     const id = getValue();
      //     return (
      //       <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      //         {/* <div
      //           className="iconDel"
      //           onClick={(e) => {
      //             e.stopPropagation();
      //             setSelectedCSVId(id);
      //             setShowModal(true);
      //           }}
      //         >
      //           <img src="/images/fi_trash-2.png" alt="Delete" /> {t('Delete')}
      //         </div> */}
      //       </div>
      //     );
      //   },
      //   colName: t('Action'),
      // },
    ],
    [t]
  );

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  const handleRowClick = (id) => {
    // navigate(`/Departmentdetail/${id}/DepartmentDetail`)
  };

  return (
    <div className="p-4 mb-4">
      <div className="pageTitle mb-4">{t("CSVFile")}</div>

      <div className="primaryBlueBox p-5 mb-4">
        <div className="row">
          <div className="col-md-4">
            <label className="form-label">{t("SearchCSVFile")}</label>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder={t("SearchbyCSVFile")}
                value={searchVal}
                onChange={(e) => setSearchVal(e.target.value)}
              />
              <button
                className="btn btn-outline-secondary btnSearchIcon"
                type="button"
              >
                <i className="bi bi-search"></i>
              </button>
            </div>
          </div>
          <div className="col-md-1">
            <div className="vrLine"></div>
          </div>
          <div className="col-md-7">
            <NavLink className="btnWhiteGradient mt-4" to="/add-CSV">
              <i className="bi bi-envelope me-2 mt-3 h6"></i> {t("AddCSV")}
            </NavLink>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="d-flex justify-content-center align-items-center my-5">
          <div
            className="spinner-border"
            role="status"
            style={{
              borderTopColor: "#6897CB",
              borderBottomColor: "#6897CB",
              borderLeftColor: "#6897CB",
              marginTop: "50px",
            }}
          ></div>
        </div>
      ) : (
        <div className="bg-light px-3 py-3 lessonsTableWrapper resTable overflow-auto">
          {window.innerWidth < 768 ? (
            table.getRowModel().rows.map((row) => (
              <div
                key={row.id}
                className="stacked-row"
                onClick={() => handleRowClick(row.original.id)}
              >
                {row.getVisibleCells().map((cell) => (
                  <div key={cell.id} className="stacked-cell">
                    <strong className="me-1">
                      {cell.column.columnDef.colName}:
                    </strong>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </div>
                ))}
              </div>
            ))
          ) : (
            <table className="table table-bordered table-hover">
              <thead>
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                      <th key={header.id}>
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody>
                {table.getRowModel().rows.map((row) => (
                  <tr key={row.id}>
                    {row.getVisibleCells().map((cell) => (
                      <td
                        key={cell.id}
                        className="rowAnchor"
                        onClick={() => handleRowClick(row.original.id)}
                      >
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      <div className="navigationWrapper">
        <ul>
          {links.map((link, index) => (
            <li
              key={index}
              className={`${link.active ? "active" : ""} ${
                link.url === null ? "disabled" : ""
              }`}
              onClick={
                link.url !== null ? () => fetchCSVfile(link.url) : undefined
              }
            >
              <div dangerouslySetInnerHTML={{ __html: link.label }} />
            </li>
          ))}
        </ul>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("ConfirmDelete")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("AreyousureyouwanttodeletethisCSV?")}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            {t("Cancel")}
          </Button>
          {/* Add delete function here if needed */}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CSVmanagement;
